export  const FirebaseConfig = {
    apiKey: "AIzaSyAxJ-N804RrCsdVnJ4r56kVFxg9aS7pIb4",
    authDomain: "microblog-felipefm32.firebaseapp.com",
    databaseURL: "https://microblog-felipefm32.firebaseio.com",
    projectId: "microblog-felipefm32",
    storageBucket: "microblog-felipefm32.appspot.com",
    messagingSenderId: "576584059616"
  };